import toast from 'react-hot-toast';
import axios from 'axios';
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS";
export const ADMIN_LOGIN_FAILURE = "ADMIN_LOGIN_FAILURE";

export const loginAction = (user, token) => (dispatch) => {
  const userWithToken = { ...user, token: token.access_token };
  dispatch({
    type: LOGIN_SUCCESS,
    payload: userWithToken,
  });
};

export const loginFailureAction = (error) => (dispatch) => {
  const errorMessage = error.message || "Login failed";
  dispatch({
    type: LOGIN_FAILURE,
    payload: errorMessage,
  });
};

export const logoutAction = () => (dispatch) => {
  localStorage.removeItem("token");
  dispatch({
    type: LOGOUT,
  });
  toast.success("Logout successful!");
};

export const refreshTokenAction = (newToken) => (dispatch) => {
  dispatch({
    type: REFRESH_TOKEN_SUCCESS,
    payload: newToken,
  });
};

export const adminLoginAction = (email, password) => async (dispatch) => {
  try {
    const response = await axios.post('https://backend.pmc-group.uk/api/admin', {
      email,
      password,
    });

    if (response.status === 200 && response.data && response.data.user) {
      dispatch({
        type: ADMIN_LOGIN_SUCCESS,
        payload: { admin: response.data.user, token: response.data.authorization.access_token },
      });

      localStorage.setItem('adminToken', response.data.authorization.access_token);
      localStorage.setItem('admin', JSON.stringify(response.data.user));

      toast.success("Admin login successful!");
      return true;
    } else {
      const errorMessage = response.data?.error?.message || "Login failed";
      dispatch({
        type: ADMIN_LOGIN_FAILURE,
        payload: errorMessage,
      });

      toast.error(errorMessage);
      return false;
    }
  } catch (error) {
    let errorMessage;

    if (!error.response) {
      errorMessage = "Network error. Please check your connection.";
      toast.error(errorMessage);
    } else if (error.response.status === 400) {
      errorMessage = "Incorrect credentials. Please try again.";
      toast.error(errorMessage);
    } else if (error.response.status === 500) {
      errorMessage = "Server error. Please try again later.";
      toast.error(errorMessage);
    } else {
      errorMessage = error.response.data?.message || "Admin login failed";
      toast.error(errorMessage);
    }

    dispatch({
      type: ADMIN_LOGIN_FAILURE,
      payload: errorMessage,
    });

    return false;
  }
};
